import { render, staticRenderFns } from "./TipoTasas.vue?vue&type=template&id=c2d45ce0"
import script from "./TipoTasas.vue?vue&type=script&lang=js"
export * from "./TipoTasas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports